<script setup lang="ts">
import { defineQuery } from "groq"
import { NuggetCard } from "#components"
import { buildMusicSchema } from "~/utils/schema"

const route = useRoute()

const MUSIC_QUERY =
  defineQuery(`*[_type == "music" && slug.current == $slug]{..., artist->{name, slug}, "nuggets": *[_type=='nugget' && references(^._id)]{
    _id,
    displayedId,
    type,
    text,
    slug,
    author->{name, slug},
    book->{title, slug},
    music->{title, slug},
  }}[0]`)
const { data: song, status } = useSanityQuery(MUSIC_QUERY, {
  slug: route.params.slug,
})

const siteConfig = useSiteConfig()

useSchemaOrg(() => buildMusicSchema(song.value, siteConfig.url))
</script>

<template>
  <div class="container mx-auto mt-32">
    <div v-if="status === 'pending'">Loading...</div>
    <div v-else-if="status === 'error'">Error</div>
    <div v-else-if="status === 'success' && song">
      <h1 class="text-4xl font-bold">{{ song.title }}</h1>
      <p v-if="song.artist" class="text-xl text-gray-500 mt-2">
        by {{ song.artist.name }}
      </p>
      <div class="grid grid-cols-1 sm:grid-cols-2 gap-4 mt-8">
        <NuggetCard
          v-for="nugget in song.nuggets"
          :key="nugget._id"
          :nugget="nugget"
          :status="status"
        />
      </div>
    </div>
  </div>
</template>
